import { Injectable }       from '@angular/core';
import {
	NotificationTargetTypeEnum,
	NotificationTypes
}                           from '@app/modules/notification/models/notification.model';
import { SanitizerService } from '@http/sanitizer.service';
import { ModelTypeEnum }    from '@models/transition.model';
import {
	NotificationBodyDTO,
	TargetTypeDTO
}                           from '@openApi/generated/notification-admin-api';
import { LoggerService }    from '@shared/services/logger.service';
import { ArrayUtils }       from '@utils/helpers';

@Injectable( {
	providedIn: 'root'
} )
export class NotificationMapperService {

	private readonly _arrayUtils = ArrayUtils;

	constructor(
		private _logger: LoggerService
	) {}

	get notification() {
		return {
			notificationToNotificationBodyDTO: this.mapNotificationToNotificationBodyDTO.bind( this ) as typeof this.mapNotificationToNotificationBodyDTO,
			targetTypeDtoToTmo: this.mapTargetTypeDtoToTmo.bind( this ) as typeof this.mapTargetTypeDtoToTmo,
			targetTypeTmoToDto: this.mapTargetTypeTmoToDto.bind( this ) as typeof this.mapTargetTypeTmoToDto
		};
	}

	private mapNotificationToNotificationBodyDTO( notification: NotificationTypes, sanitize: SanitizerService ): NotificationBodyDTO {
		return {
			notificationDate: sanitize.date<string>( notification?.formBody?.notificationDate, ModelTypeEnum.DTO ),
			message: notification?.formBody?.message,
			subject: notification?.formBody?.subject,
			targetId: this._arrayUtils.checkForArrayArgAndReturnAsSingleValue( notification?.formBody?.targetId ),
			targetType: this.notification.targetTypeTmoToDto( notification?.formBody?.targetType )
		};
	}

	private mapTargetTypeDtoToTmo( targetType: TargetTypeDTO ): NotificationTargetTypeEnum {
		switch ( targetType ) {
			case TargetTypeDTO.ALL:
				return NotificationTargetTypeEnum.ALL;

			case TargetTypeDTO.BUSINESS_PREMISES:
				return NotificationTargetTypeEnum.BUSINESS_PREMISES;

			case TargetTypeDTO.ORGANIZATION:
				return NotificationTargetTypeEnum.ORGANIZATION;

			case TargetTypeDTO.TENANT:
				return NotificationTargetTypeEnum.TENANT;

			default:
				if ( targetType ) {
					this._logger.warn( `mapTargetTypeDtoToTmo has no case for DTO ${ targetType }` );
				}
				return null;
		}
	}

	private mapTargetTypeTmoToDto( targetType: NotificationTargetTypeEnum ): TargetTypeDTO {
		switch ( targetType ) {
			case NotificationTargetTypeEnum.ALL:
				return TargetTypeDTO.ALL;

			case NotificationTargetTypeEnum.BUSINESS_PREMISES:
				return TargetTypeDTO.BUSINESS_PREMISES;

			case NotificationTargetTypeEnum.ORGANIZATION:
				return TargetTypeDTO.ORGANIZATION;

			case NotificationTargetTypeEnum.TENANT:
				return TargetTypeDTO.TENANT;

			default:
				if ( targetType ) {
					this._logger.warn( `mapTargetTypeTmoToDto has no case for TMO ${ targetType }` );
				}
				return null;
		}
	}
}
